import { SubAPI } from "./SubAPI";

// only the built-in admin account reaches these
export class Admin extends SubAPI {
    listUsers() {
        return this.fetcher.get<AdminUser[]>("/api/admin/users");
    }

    // a user added here is confirmed already. password sets a new one.
    upsertUser(props: { id?: number; email: string; firstName: string; lastName: string; archived: boolean; password?: string }) {
        return this.fetcher.post<AdminUser>("/api/admin/user", props);
    }

    listTeams() {
        return this.fetcher.get<AdminTeam[]>("/api/admin/teams");
    }

    // members is the whole list of user ids; they're added and removed with no invite
    upsertTeam(props: { id?: number; name: string; archived: boolean; members: number[] }) {
        return this.fetcher.post<AdminTeam>("/api/admin/team", props);
    }

    // starts a session as the user. A full page load should follow.
    masquerade(props: { usr: number }) {
        return this.fetcher.post<null>("/api/admin/masquerade", props);
    }

    stopMasquerade(props: {}) {
        return this.fetcher.post<null>("/api/admin/masquerade/stop", props);
    }
}

export type AdminUser = {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    confirmedAt: string | null;
    archived: boolean;

    // archived because the email was never confirmed
    archivedUnconfirmed: boolean;

    lastActiveAt: string | null;
    teamCount: number;
    createdAt: string;

    // the built-in admin account, which can't be changed here
    isAdmin: boolean;
}

export type AdminTeam = {
    id: number;
    name: string;
    personal: boolean;
    archived: boolean;
    createdAt: string;
    members: { usr: number; name: string; email: string }[];
}
